'use es6';

import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticsToolsComponent from '../analyticsToolsBeta/components/AnalyticsToolsComponent';
import { getGatesAndScopes, getIsUngatedForPipelineSnapshotsAlert } from '../selectors/gatesSelector';
import { trackEvent, EVENTS } from '../lib/usageTracker';
import { recordRecentlyViewedTemplate } from '../utils/recentlyViewedTemplatesUtils';
import { fetchReportCollectionTemplates, selectIsReportCollectionTemplateRequestPending } from '../redux/reportCollectionTemplates';
import { findCategoryParent } from '../config/analyticTools';
import AnalyticsAccessWrapper from './AnalyticsAccessWrapper';
import AnalyticsReportViewer from '../components/analyticsSuites/AnalyticsReportViewer';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import * as storage from 'reporting-data/lib/storage';
import { SUITE_SCREEN_NAMES } from '../constants/screenNames';
import { REVENUE_SUB_APP } from '../constants/templates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TemplatesPageContainer = () => {
  const {
    collectionId,
    templateId: subAppKey
  } = useParams();
  const dispatch = useDispatch();
  const isLegacyRevenue = subAppKey === REVENUE_SUB_APP;
  const [isSnapshotBannerVisible, setIsSnapshotBannerVisible] = useState(true);
  const HAS_SEEN_SNAPSHOTS_ALERT = 'templatesPage:hasSeenSnapshotsAlert';
  const isCollectionTemplatesRequestPending = useSelector(selectIsReportCollectionTemplateRequestPending);
  const isUngatedForPipelineSnapshotsAlert = useSelector(getIsUngatedForPipelineSnapshotsAlert);
  const {
    gates: userAccessGates,
    scopes: userAccessScopes
  } = useSelector(getGatesAndScopes);
  const categoryIA = subAppKey && findCategoryParent(collectionId, subAppKey, userAccessGates, userAccessScopes);
  const derivedCategoryId = categoryIA ? categoryIA.get('id') : undefined;
  useEffect(() => {
    dispatch(fetchReportCollectionTemplates());
  }, [dispatch]);
  useEffect(() => {
    if (!isLegacyRevenue) {
      const screen = SUITE_SCREEN_NAMES[collectionId];
      trackEvent(EVENTS.analyticsToolDayZero, {
        screen,
        subscreen: subAppKey
      });
      trackEvent(EVENTS.pageView, {
        screen,
        subscreen: subAppKey,
        whichStage: 'analytics-report'
      });
      recordRecentlyViewedTemplate(subAppKey, collectionId, derivedCategoryId);
    }
  }, [collectionId, derivedCategoryId, isLegacyRevenue, subAppKey]);
  const childComponent = useMemo(() => {
    if (isLegacyRevenue) {
      return /*#__PURE__*/_jsx(AnalyticsToolsComponent, {});
    }
    return !isCollectionTemplatesRequestPending && /*#__PURE__*/_jsx(AnalyticsReportViewer, {
      subAppKey: subAppKey
    });
  }, [isCollectionTemplatesRequestPending, isLegacyRevenue, subAppKey]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "TEMPLATES_PAGE_CONTAINER",
    children: /*#__PURE__*/_jsx(AnalyticsAccessWrapper, {
      children: /*#__PURE__*/_jsxs("div", {
        "data-test-id": "templates-page-container",
        children: [subAppKey === SUB_APPS.pipelineSnapshots && isSnapshotBannerVisible && storage.get(HAS_SEEN_SNAPSHOTS_ALERT) !== 'true' && isUngatedForPipelineSnapshotsAlert && /*#__PURE__*/_jsx(Alert, {
          closeable: true,
          onClose: () => {
            setIsSnapshotBannerVisible(false);
            storage.set(HAS_SEEN_SNAPSHOTS_ALERT, 'true');
          },
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.pipelineSnapshotsAlert.heading"
          }),
          type: "info",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.pipelineSnapshotsAlert.subtext"
          })
        }), childComponent]
      })
    })
  });
};
export default TemplatesPageContainer;